import styled from "styled-components";

export const ParentContainer = styled.section`
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 70%;
    margin: 0 auto;
    @media ${(props) => 'screen and (max-width: 1280px)'} { 
        grid-template-columns: 1fr;
        max-width: 80%;
    }
`;

export const LeftContainer = styled.section`
    padding-bottom: 2rem;
`;

export const RightContainer = styled.section`
    padding-bottom: 2rem;
`;

export const Title = styled.h2`
    color: white;
    font-weight: 800;
    font-size: 65px;
    margin-bottom: 10px;
    @media ${(props) => 'screen and (max-width: 900px)'} {
        font-size: 48px;
        font-weight: 600;
    }
`;

export const BodyTitle = styled.h2`
    color: white;
    font-weight: 700;
    font-size: 60px;
    margin-top: 0;
    @media ${(props) => 'screen and (max-width: 900px)'} {
        font-size: 42px;
        font-weight: 500;
    }
`;

export const Body = styled.p`
    color: rgba(255, 255, 255, 0.5);
    font-size: 22px;
    max-width: 500px;
    margin: auto;
    padding: 1rem;
    @media ${(props) => 'screen and (max-width: 900px)'} {
        font-size: 18px;
    }
`;

export const ImageWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Img = styled.img`
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 50%;
    max-width: 500px;

    @media ${(props) => 'screen and (max-width: 900px)'} {
        max-width: 300px;
  }
`;

export const SectionDivider = styled.div`
    width: 100px;
    height: 6px;
    border-radius: 10px;
    background-color: #fff;
    background: ${(props) => props.colorAlt ? 
        'linear-gradient(270deg, #F46737 0%, #945DD6 100%)' :
        'linear-gradient(270deg, #13ADC7 0%, #945DD6 100%)'};

        margin: ${(props) => props.divider ? "4rem 0" : "" };
`;